import React, { useState } from "react";
import { useSiteSettings } from "../hooks/useSiteSettings";

export default function SiteBanner() {
  const settings = useSiteSettings();
  const [dismissed, setDismissed] = useState(false);

  if (settings.banner_enabled !== "true" || !settings.banner_message || dismissed) {
    return null;
  }

  return (
    <div
      className="w-full text-white text-sm font-medium px-4 py-2.5 flex items-center justify-center gap-3 relative"
      style={{ background: "linear-gradient(to right, var(--brand-from), var(--brand-to))" }}
      role="banner"
    >
      <span>{settings.banner_message}</span>
      <button
        onClick={() => setDismissed(true)}
        aria-label="Dismiss banner"
        className="absolute right-4 top-1/2 -translate-y-1/2 opacity-70 hover:opacity-100 transition text-lg leading-none"
      >
        ×
      </button>
    </div>
  );
}
